import React, { useEffect, useState, useRef } from "react";

import Slider from "react-slick";

import { useParams, useLocation, Link } from "react-router-dom";

import { api } from "../Constants";

import axios from "axios";

import { Helmet } from "react-helmet";

import Modal from "react-bootstrap/Modal";

import ReCAPTCHA from "react-google-recaptcha";

import Customarrows from "../Homepage/Customarrows";

import { useDispatch, useSelector } from "react-redux";

import { addtoCart } from "../../features/cartSlice";

import { fetchCartitemslice } from "../../features/cartItemSlice";

import { toast } from "react-toastify";

import Header from "../Header/Header";

import Footer from "../Footer/Footer";

import Breadcrump from "../Breadcrump/Breadcrump";

import Productdetailscarousel from "./Productdetailscarousel";

function Productdetail() {

  const routePath = useLocation();

  const userid = localStorage.getItem("userid");

  const [quantity, setQuantity] = useState(1);

  const dispatch = useDispatch();



  const onTop = () => {

    window.scrollTo(0, 0);

  };



  const [selectedSizes, setSelectedSizes] = useState([]);



  const { cartItems } = useSelector((state) => state.cartListslice);



  const Isincart = (productid) => {

    const productitems = cartItems.find(

      (listitems) => listitems.id === productid

    );

    return productitems;

  };



  useEffect(() => {

    onTop();

  }, [routePath]);



  //   const handleChangeCart = (e) => {

  //   const { name, value } = e.target;

  //   setFormdatacart({ ...formdatacart, [name]: value });

  // };



  var subject = "testing";

  const [loading, setLoading] = useState(true);

  const params = useParams();

  var prd_slugname = params.slug_name;



  const [show, setShow] = useState(false);

  const handleClose = () => setShow(false);



  const handleShow = (item) => {

    setShow(true);

    setFormData({

      ...formData,

      product_code: item.product_code,

      product_id: item.product_id,

      dealer_id: userid,

      subject: subject,

      qty: quantity,

      size: selectedSizes.join(","),

    });

  };

  const handleChange = (e) => {

    const { name, value } = e.target;

    setFormData({ ...formData, [name]: value });

  };

  const handleChange1 = (e) => {

    const { name, value } = e.target;

    setFormData({ ...formData, [name]: value });

  };

  const handleChange2 = (e) => {

    const { name, value } = e.target;

    setFormData({ ...formData, [name]: value });

  };

  const handleChange3 = (e) => {

    const { name, value } = e.target;

    setFormData({ ...formData, [name]: value });

  };

  const handleChange4 = (e) => {

    const { name, value } = e.target;

    setFormData({ ...formData, [name]: value });

  };



  const [formData, setFormData] = useState({

    name: "",

    mobile: "",

    email: "",

    city: "",

    message: "",

    qty: "",

    size: "",

    subject,

  });



  const handleClick = () => {

    if (

      !formData.name == "" &&

      !formData.mobile == "" &&

      !formData.email == "" &&

      !formData.city == "" &&

      !formData.message == ""

    ) {

      fetch(api + "add_enquirydetails", {

        method: "POST",

        headers: {

          Accept: "application/json",

          "Content-Type": "application/json;charset=UTF-8",

          changeOrigin: true,

        },

        body: JSON.stringify(formData),

      }).then((response) => {

        if (response.status === 200) {

          alert("send message succesfully");

          handleClose();

        } else alert("some error is occured");

      });

    }

  };



  var settings = {

    dots: false,

    infinite: true,

    speed: 300,

    slidesToShow: 4,

    slidesToScroll: 1,

    autoplay: true,

    autoplaySpeed: 3000,

    prevArrow: <Customarrows className="slick-prev" isNext={false} />,

    nextArrow: <Customarrows className="slick-next" isNext={true} />,

    responsive: [

      {

        breakpoint: 1024,

        settings: {

          slidesToShow: 3,

          slidesToScroll: 1,

          infinite: true,

          dots: false,

        },

      },

      {

        breakpoint: 991,

        settings: {

          slidesToShow: 2,

          slidesToScroll: 1,

          infinite: true,

          dots: false,

        },

      },

      {

        breakpoint: 600,

        settings: {

          slidesToShow: 2,

          slidesToScroll: 1,

        },

      },

      {

        breakpoint: 480,

        settings: {

          slidesToShow: 1,

          slidesToScroll: 1,

        },

      },

    ],

  };



  const [data, setData] = useState([]);



  useEffect(() => {

    axios

      .post(api + "search_slugproduct", {

        slug: prd_slugname,

        dealer_id: userid,

      })

      .then((response) => {

        setData(response.data.data);

        setLoading(false);

      })

      .catch((error) => {

        if (error.response) {

          // console.log(error.response)

        } else if (error.request) {

          // console.log(error.request)

        } else {

          // console.log("error")

        }

      });

  }, [params]);



  function onChange(value) {

    console.log("Captcha value:", value);

  }



  const handleAddtocart = (product_id) => {

    if (userid) {

      dispatch(addtoCart({ product_id, userid }));

    }

  };



  const Quantityincrease = () => {

    setQuantity(quantity + 1);

  };



  const Quantitydecrease = () => {

    if (quantity <= 1) {

      return false;

    }

    setQuantity(quantity - 1);

  };



  const zoomableRef = useRef(null);



  useEffect(() => {

    if (zoomableRef.current) {

      new window.Zoomable(zoomableRef.current); // `Zoomable` must be globally available

    }

  }, []);



  const [showcart, setShowcart] = useState(false);

  const handleClosecart = () => setShowcart(false);



  const handleShowcart = (item) => {

    setShowcart(true);



    // const quantityVariant =

    //   typeof item.quantity_variant === "object"

    //     ? item.quantity_variant.quantity_variant || ""

    //     : item.quantity_variant || "Pair";



    carsetFormData((prev) => ({

      ...prev,

      product_id: item.product_id,

      product_code: item.product_code,

      quantity_variant: item.quantity_variant.quantity_variant,

    }));

  };



  // Add this at the top of your component

  const [cartformData, carsetFormData] = useState({

    qty: "",

    sizes: "",

    carat: "",

    weight: "",

    remarks: "",

    quantity_variant: "",

  });

  // const [loading, setLoading] = useState(false);

  const [error, setError] = useState("");



  const carthandleChange = (e) => {

    const { name, value } = e.target;

    carsetFormData((prev) => ({

      ...prev,

      [name]: value,

    }));

  };



  const handleSubmit = async (e) => {

    e.preventDefault();



    const userids = userid;

    const product_id = parseInt(cartformData.product_id);

    const qty = parseInt(cartformData.qty);

    const size = cartformData.sizes;

    const carat = cartformData.carat;

    const weight = cartformData.weight;

    const remarks = cartformData.remarks;



    if (userid) {

      try {

        const resultAction = await dispatch(

          addtoCart({ product_id, userids, qty, size, carat, weight, remarks })

        );



        if (resultAction.payload.success) {

          // Adjust condition based on your setup

          handleClosecart();

          carsetFormData((prev) => ({

            ...prev,

            qty: "",

            sizes: "",

            carat: "",

            weight: "",

            remarks: "",

          }));

        }

      } catch (error) {

        console.error(error);

        // Handle error appropriately (e.g., show a message to the user)

      }

    }

  };



  return (

    <>

      <div>

        <Helmet>

          <title>Product Details</title>

        </Helmet>

      </div>

      {loading ? (

        <div style={{ height: "100vh" }}>

          <div className="container" style={{ height: "100%" }}>

            <div className="row" style={{ height: "100%" }}>

              <div className="col-12" style={{ height: "100%" }}>

                <div

                  style={{

                    display: "flex",

                    justifyContent: "center",

                    padding: "10px",

                    height: "100%",

                  }}

                >

                  <div class="dot-spinner">

                    <div class="dot-spinner__dot"></div>

                    <div class="dot-spinner__dot"></div>

                    <div class="dot-spinner__dot"></div>

                    <div class="dot-spinner__dot"></div>

                    <div class="dot-spinner__dot"></div>

                    <div class="dot-spinner__dot"></div>

                    <div class="dot-spinner__dot"></div>

                    <div class="dot-spinner__dot"></div>

                  </div>

                </div>

              </div>

            </div>

          </div>

        </div>

      ) : (

        <>

          <Header />

          <Breadcrump cont2="Product Details" />

          {data !== undefined && data.length > 0

            ? data.map((item) => {

                return (

                  <div>

                    <div class="shop-main-wrapper section-padding pb-0">

                      <div class="container">

                        <div class="row">

                          <div class="col-lg-12 order-1 order-lg-2">

                            <div class="product-details-inner">

                              <div class="row">

                                <div className="d-flex">

                                  <div

                                    class="col-lg-5"

                                    style={{ position: "relative" }}

                                  >

                                    {/* <div class="product-large-slider">

                                    <div class="pro-large-img">

                                      <ZoomPreviewImage

                                        src={item.product_image}

                                        alt="product-details"

                                      />

                                    </div>

                                  </div> */}

                                    <Productdetailscarousel items={item} />

                                  </div>

                                  <div class="col-lg-7">

                                    <div class="product-details-des mx-5">

                                      <h3 class="product-name">{item.name}</h3>

                                      <table>

                                        <tr>

                                          <td colspan="1">

                                            <p class="manufacturer-name prod-detcode-color">

                                              Quantity

                                            </p>

                                          </td>

                                          <td

                                            style={{

                                              paddingLeft: "4px",

                                              paddingRight: "4px",

                                            }}

                                          >

                                            {" "}

                                            :{" "}

                                          </td>

                                          <td>

                                            <p class="manufacturer-name prod-detcode-color">

                                              <span>

                                                {item.quantity}&nbsp;

                                                {

                                                  item.quantity_variant

                                                    .quantity_variant

                                                }

                                              </span>

                                            </p>

                                          </td>

                                        </tr>



                                        <tr>

                                          <td colspan="1">

                                            <p class="manufacturer-name prod-detcode-color">

                                              Weight

                                            </p>

                                          </td>

                                          <td

                                            style={{

                                              paddingLeft: "4px",

                                              paddingRight: "4px",

                                            }}

                                          >

                                            {" "}

                                            :{" "}

                                          </td>

                                          <td>

                                            <p class="manufacturer-name prod-detcode-color">

                                              <span>{item.weight}&nbsp;</span>

                                            </p>

                                          </td>

                                        </tr>



                                        <tr>

                                          <td colspan="1">

                                            {" "}

                                            <p class="manufacturer-name prod-detcode-color">

                                              SKU

                                            </p>

                                          </td>

                                          <td

                                            style={{

                                              paddingLeft: "4px",

                                              paddingRight: "4px",

                                            }}

                                          >

                                            {" "}

                                            :{" "}

                                          </td>

                                          <td>

                                            <p class="manufacturer-name prod-detcode-color">

                                              <span> {item.product_code}</span>

                                            </p>

                                          </td>

                                        </tr>



                                        <tr>

                                          <td colspan="1">

                                            {" "}

                                            <p class="manufacturer-name prod-detcode-color">

                                              Collections{" "}

                                            </p>

                                          </td>

                                          <td

                                            style={{

                                              paddingLeft: "4px",

                                              paddingRight: "4px",

                                            }}

                                          >

                                            {" "}

                                            :{" "}

                                          </td>

                                          <td>

                                            {" "}

                                            <p class="manufacturer-name prod-detcode-color">

                                              {" "}

                                              <Link

                                                to={`/category/${item.category_slug_name}`}

                                              >

                                                {item.category_name}

                                              </Link>

                                            </p>

                                          </td>

                                        </tr>


                                        <tr>

                                          <td colspan="1">

                                            {" "}

                                            <p class="manufacturer-name prod-detcode-color">

                                              Keyword{" "}

                                            </p>

                                          </td>

                                          <td

                                            style={{

                                              paddingLeft: "4px",

                                              paddingRight: "4px",

                                            }}

                                          >

                                            {" "}

                                            :{" "}

                                          </td>

                                          <td>

                                            {" "}

                                            <p class="manufacturer-name prod-detcode-color" style={{ color: "#bc1823"}}>

                                              {" "}

                                            
                                               {item.keyword}

                                            </p>

                                          </td>

                                        </tr>

                                        <tr>

                                          <td colspan="1">

                                            {" "}

                                            {item.customized ? (

                                              <p className="manufacturer-name prod-detcode-color d-flex">

                                                Customization

                                              </p>

                                            ) : null}

                                          </td>

                                          <td>

                                            {" "}

                                            {item.customized ? (

                                              <div

                                                style={{ paddingLeft: "4px" }}

                                              >

                                                :

                                              </div>

                                            ) : null}

                                          </td>

                                          <td>

                                            {item.customized ? (

                                              <p className="manufacturer-name prod-detcode-color d-flex">

                                                <span

                                                  className="mx-1"

                                                  dangerouslySetInnerHTML={{

                                                    __html: item.customized,

                                                  }}

                                                ></span>

                                              </p>

                                            ) : null}

                                          </td>

                                        </tr>

                                        

                                        <tr>

                                          <td colspan="1">

                                            {" "}

                                            {item.description ? (

                                              <p class="pro-desc d-flex prod-detcode-color">

                                                Description{" "}

                                              </p>

                                            ) : null}

                                          </td>

                                          <td>

                                            {" "}

                                            {item.description ? (

                                              <div>:</div>

                                            ) : null}

                                          </td>

                                          <td>

                                            {" "}

                                            {item.description ? (

                                              <p class="pro-desc d-flex prod-detcode-color">

                                                {" "}

                                                <span

                                                  dangerouslySetInnerHTML={{

                                                    __html: item.description,

                                                  }}

                                                ></span>

                                              </p>

                                            ) : null}

                                          </td>

                                        </tr>

                                      </table>



                                      {userid ? (

                                        <>

                                          <div class="quantity-cart-box d-flex align-items-center">

                                            <div class="action_link">

                                              {userid ? (

                                                <>

                                                  <button

                                                    className="btn btn-cart2"

                                                    onClick={() => {

                                                      handleShowcart(item);

                                                    }}

                                                  >

                                                    Add to Cart

                                                  </button>

                                                </>

                                              ) : (

                                                <>

                                                  <button

                                                    className="btn btn-cart2"

                                                    onClick={() => {

                                                      handleShow(item);

                                                    }}

                                                  >

                                                    Enquiry Now

                                                  </button>

                                                </>

                                              )}

                                            </div>

                                          </div>

                                        </>

                                      ) : (

                                        <>

                                          <div class="quantity-cart-box d-flex align-items-center">

                                            <div class="action_link">

                                              <a

                                                class="btn btn-cart2"

                                                href="javascript:void(0);"

                                                onClick={() => {

                                                  handleShow(item);

                                                }}

                                              >

                                                Enquiry Now

                                              </a>

                                            </div>

                                          </div>

                                        </>

                                      )}

                                    </div>

                                  </div>

                                </div>

                              </div>

                            </div>

                          </div>

                        </div>

                      </div>

                    </div>

                    <section class="related-products section-padding">

                      <div class="container">

                        <div class="row">

                          <div class="col-12">

                            <div class="section-title text-center">

                              <h2 class="title">Related Designs</h2>

                            </div>

                          </div>

                        </div>

                        <div class="row">

                          <div class="col-12">

                            <div class="product-carousel-4 ">

                              {item.related_product.length > 3 ? (

                                <>

                                  <Slider {...settings}>

                                    {item.related_product !== undefined &&

                                    item.related_product.length > 0

                                      ? item.related_product.map((st) => {

                                          return (

                                            <div class="product-item">

                                              <figure class="product-thumb">

                                                <Link

                                                  to={`/product-details/${st.prd_slug_name}`}

                                                >

                                                  <img

                                                    class="pri-img"

                                                    src={st.product_image}

                                                    alt="product"

                                                  />

                                                </Link>



                                                <div class="cart-hover">

                                                  <Link

                                                    class="btn btn-cart"

                                                    to={`/product-details/${st.prd_slug_name}`}

                                                  >

                                                    View More

                                                  </Link>

                                                </div>

                                              </figure>

                                              <div class="product-caption text-center">

                                                <h6 class="product-name">

                                                  <Link

                                                    to={`/product-details/${st.prd_slug_name}`}

                                                  >

                                                    {st.category_slug_name}

                                                  </Link>

                                                </h6>



                                                <div class="product-identity">

                                                  <p class="manufacturer-name">

                                                    Qty :{" "}

                                                    <span

                                                      className="price-regular"

                                                      style={{

                                                        paddingLeft: "3px",

                                                      }}

                                                    >

                                                      {" "}

                                                      {st.quantity}

                                                      <span

                                                        style={{

                                                          paddingLeft: "3px",

                                                        }}

                                                      >

                                                        {" "}

                                                        {

                                                          st.quantity_variant

                                                            .quantity_variant

                                                        }

                                                      </span>{" "}

                                                    </span>

                                                  </p>

                                                </div>



                                                <div class="product-identity">

                                                  <p class="manufacturer-name">

                                                    Weight :

                                                    <span className="price-regular">

                                                      {" "}

                                                      {st.weight} g

                                                    </span>

                                                  </p>

                                                </div>



                                                <div class="price-box">

                                                  <span class="price-old">

                                                    SKU :{" "}

                                                  </span>

                                                  <span class="price-regular">

                                                    {st.product_code}{" "}

                                                  </span>

                                                </div>

                                              </div>

                                            </div>

                                          );

                                        })

                                      : null}

                                  </Slider>

                                </>

                              ) : item.related_product.length === 2 ? (

                                <>

                                  <div

                                    className="row"

                                    style={{ justifyContent: "center" }}

                                  >

                                    {item.related_product.map((item, index) => {

                                      return (

                                        <>

                                          <div className="col-3">

                                            <div class="product-item">

                                              <figure class="product-thumb">

                                                <Link

                                                  to={`/product-details/${item.prd_slug_name}`}

                                                >

                                                  <img

                                                    class="pri-img"

                                                    src={item.product_image}

                                                    alt="product"

                                                  />

                                                </Link>



                                                <div class="cart-hover">

                                                  <Link

                                                    class="btn btn-cart"

                                                    to={`/product-details/${item.prd_slug_name}`}

                                                  >

                                                    View More

                                                  </Link>

                                                </div>

                                              </figure>

                                              <div class="product-caption text-center">

                                                <h6 class="product-name">

                                                  <Link

                                                    to={`/product-details/${item.prd_slug_name}`}

                                                  >

                                                    {item.category_slug_name}

                                                  </Link>

                                                </h6>



                                                <div class="product-identity">

                                                  <p class="manufacturer-name">

                                                    Qty :{" "}

                                                    <span className="price-regular">

                                                      {" "}

                                                      {

                                                        item.quantity

                                                      } &nbsp;{" "}

                                                      {

                                                        item.quantity_variant

                                                          .quantity_variant

                                                      }{" "}

                                                    </span>

                                                  </p>

                                                </div>



                                                <div class="product-identity">

                                                  <p class="manufacturer-name">

                                                    Weight :

                                                    <span className="price-regular">

                                                      {" "}

                                                      {item.weight} g

                                                    </span>

                                                  </p>

                                                </div>



                                                <div class="price-box">

                                                  <span class="price-old">

                                                    SKU :{" "}

                                                  </span>

                                                  <span class="price-regular">

                                                    {item.product_code}{" "}

                                                  </span>

                                                </div>

                                              </div>

                                            </div>

                                          </div>

                                        </>

                                      );

                                    })}

                                  </div>

                                </>

                              ) : item.related_product.length === 1 ? (

                                <>

                                  <div

                                    className="row"

                                    style={{ justifyContent: "center" }}

                                  >

                                    {item.related_product.map((item, index) => {

                                      return (

                                        <>

                                          <div className="col-3">

                                            <div class="product-item">

                                              <figure class="product-thumb">

                                                <Link

                                                  to={`/product-details/${item.prd_slug_name}`}

                                                >

                                                  <img

                                                    class="pri-img"

                                                    src={item.product_image}

                                                    alt="product"

                                                  />

                                                </Link>



                                                <div class="cart-hover">

                                                  <Link

                                                    class="btn btn-cart"

                                                    to={`/product-details/${item.prd_slug_name}`}

                                                  >

                                                    View More

                                                  </Link>

                                                </div>

                                              </figure>

                                              <div class="product-caption text-center">

                                                <h6 class="product-name">

                                                  <Link

                                                    to={`/product-details/${item.prd_slug_name}`}

                                                  >

                                                    {item.category_slug_name}

                                                  </Link>

                                                </h6>



                                                <div class="product-identity">

                                                  <p class="manufacturer-name">

                                                    Qty :{" "}

                                                    <span className="price-regular">

                                                      {" "}

                                                      {

                                                        item.quantity

                                                      } &nbsp;{" "}

                                                      {

                                                        item.quantity_variant

                                                          .quantity_variant

                                                      }{" "}

                                                    </span>

                                                  </p>

                                                </div>



                                                <div class="product-identity">

                                                  <p class="manufacturer-name">

                                                    Weight :

                                                    <span className="price-regular">

                                                      {" "}

                                                      {item.weight} g

                                                    </span>

                                                  </p>

                                                </div>



                                                <div class="price-box">

                                                  <span class="price-old">

                                                    SKU :{" "}

                                                  </span>

                                                  <span class="price-regular">

                                                    {item.product_code}{" "}

                                                  </span>

                                                </div>

                                              </div>

                                            </div>

                                          </div>

                                        </>

                                      );

                                    })}

                                  </div>

                                </>

                              ) : null}



                              <Modal

                                show={show}

                                onHide={handleClose}

                                className="modal fade entry-popup"

                              >

                                <div className="modal-header">

                                  <h5

                                    className="modal-title"

                                    id="exampleModalLabel"

                                  >

                                    {" "}

                                    <span>For Enquiry Enter Your Details</span>

                                  </h5>

                                  <button

                                    type="button"

                                    className="close"

                                    data-dismiss="modal"

                                    aria-label="Close"

                                    style={{ border: "none" }}

                                    onClick={() => {

                                      setShow(false);

                                    }}

                                  >

                                    <span

                                      className="contactclosebutton"

                                      aria-hidden="true"

                                    >

                                      &times;

                                    </span>

                                  </button>

                                </div>

                                <Modal.Body>

                                  <form

                                    method="POST"

                                    action="javascript:void(0)"

                                  >

                                    <div className="row mb3 g-3">

                                      <div className="col-lg-12 col-md-12 mb20">

                                        <input

                                          type="text"

                                          className="form-control"

                                          placeholder="Your Name"

                                          id="name"

                                          name="name"

                                          value={formData.name}

                                          onChange={handleChange}

                                          onKeyPress={(event) => {

                                            if (!/[a-z,A-Z]/.test(event.key)) {

                                              event.preventDefault();

                                            }

                                          }}

                                          required

                                        ></input>

                                      </div>

                                      <div className="col-lg-12 col-md-12 mb20">

                                        <input

                                          type="text"

                                          className="form-control"

                                          placeholder="Phone Number"

                                          id="mobile"

                                          name="mobile"

                                          value={formData.mobile}

                                          onChange={handleChange1}

                                          maxLength="10"

                                          onKeyPress={(event) => {

                                            if (!/[0-9]/.test(event.key)) {

                                              event.preventDefault();

                                            }

                                          }}

                                          required

                                        ></input>

                                      </div>

                                      <div className="col-lg-12 col-md-12 mb20">

                                        <input

                                          type="email"

                                          className="form-control"

                                          placeholder="Email Address"

                                          id="email"

                                          name="email"

                                          value={formData.email}

                                          onChange={handleChange2}

                                          required

                                        ></input>

                                      </div>



                                      <div className="col-lg-12 col-md-12 mb20">

                                        <input

                                          type="text"

                                          className="form-control"

                                          placeholder="Enter You City"

                                          id="city"

                                          name="city"

                                          value={formData.city}

                                          onChange={handleChange4}

                                          required

                                        ></input>

                                      </div>

                                      <div class="col-lg-12 col-sm-12 mb20">

                                        <textarea

                                          type="Message"

                                          class="form-control"

                                          placeholder="Message"

                                          id="message"

                                          name="message"

                                          value={formData.message}

                                          onChange={handleChange3}

                                          required

                                        ></textarea>

                                        <small

                                          id="messageerror"

                                          class="error"

                                        ></small>

                                      </div>

                                      <div>

                                        {/* <div className="col-lg-12 col-md-12 mb20">

                                      <ReCAPTCHA

                                        sitekey={

                                          "6LdGiY0oAAAAAH9EQi94D43RkIXkRWpc1x99AUTv"

                                        }

                                        Secret

                                        Key={

                                          "6LdGiY0oAAAAALltd2vMsg0i0HeJ9J33rYDM7pnP"

                                        }

                                        className="g-recaptcha my-3"

                                        onChange={onChange}

                                      />

                                    </div> */}

                                        <Modal.Footer className="validationpopup-button-sec">

                                          <button

                                            className="main-btn mr2"

                                            download=""

                                            onClick={handleClick}

                                          >

                                            Submit

                                          </button>

                                          <button

                                            type="close"

                                            className="main-btn ml2 closebtn"

                                            data-dismiss="modal"

                                            onClick={() => {

                                              setShow(false);

                                            }}

                                          >

                                            close

                                          </button>

                                        </Modal.Footer>

                                      </div>

                                    </div>

                                  </form>

                                </Modal.Body>

                              </Modal>



                              <Modal

                                show={showcart}

                                onHide={handleClosecart}

                                keyboard={false}

                                backdrop="static"

                                className="entry-popup"

                                centered

                              >

                                <div className="modal-header mb-3">

                                  <h5 className="modal-title">Add Cart</h5>

                                  <button

                                    type="button"

                                    className="close"

                                    onClick={handleClosecart}

                                    style={{ border: "none" }}

                                  >

                                    <span className="contactclosebutton">

                                      &times;

                                    </span>

                                  </button>

                                </div>



                                <Modal.Body>

                                  <form onSubmit={handleSubmit}>

                                    {error && (

                                      <div className="alert alert-danger">

                                        {error}

                                      </div>

                                    )}



                                    <div className="row g-3">

                                      {/* Update all inputs to use cartformData */}



                                      <div className="col-12 mb20 add_to_cart_popup">

                                        <div className="input_inner_box">

                                          <input

                                            type="text"

                                            className="form-control"

                                            placeholder="Quantity"

                                            name="qty"

                                            value={cartformData.qty}

                                            onChange={carthandleChange}

                                            required

                                          />

                                          <span className="input_sub_inner_box">

                                            {cartformData.quantity_variant}

                                          </span>

                                        </div>

                                      </div>



                                      {/** Sizes **/}

                                      <div className="col-12 mb20 add_to_cart_popup">

                                        <div className="input_inner_box">

                                          <input

                                            type="text"

                                            className="form-control"

                                            placeholder="Sizes"

                                            name="sizes"

                                            value={cartformData.sizes}

                                            onChange={carthandleChange}

                                            required

                                          />

                                          <span className="input_sub_inner_box">

                                            / 16

                                          </span>

                                        </div>

                                      </div>



                                      {/** Carat **/}

                                      <div className="col-12 mb20 add_to_cart_popup">

                                        <div className="input_inner_box">

                                          <select

                                            className="form-control"

                                            name="carat"

                                            value={cartformData.carat}

                                            onChange={carthandleChange}

                                            required

                                          >

                                            <option value="" disabled>

                                              Select Carat

                                            </option>

                                            <option value="22 KT">22 KT</option>

                                            <option value="18 KT Yellow Gold">

                                              18 KT Yellow Gold

                                            </option>

                                            <option value="18KT Rose Gold">

                                              18 KT Rose Gold

                                            </option>

                                            <option value="18KT White Gold">

                                              18 KT White Gold

                                            </option>



                                            {/* Add more options as needed */}

                                          </select>

                                          <span className="input_sub_inner_box">

                                            CT

                                          </span>

                                        </div>

                                      </div>



                                      {/** Weight **/}

                                      <div className="col-12 mb20 add_to_cart_popup">

                                        <div className="input_inner_box">

                                          <input

                                            type="text"

                                            className="form-control"

                                            placeholder="Weight"

                                            name="weight"

                                            value={cartformData.weight}

                                            onChange={carthandleChange}

                                            required

                                          />

                                          <span className="input_sub_inner_box">

                                            gms

                                          </span>

                                        </div>

                                      </div>



                                      {/** Remarks **/}

                                      <div className="col-12 mb20">

                                        <textarea

                                          rows={5}

                                          className="form-control"

                                          placeholder="Remarks"

                                          name="remarks"

                                          value={cartformData.remarks}

                                          onChange={carthandleChange}

                                          required

                                        />

                                      </div>

                                    </div>



                                    <Modal.Footer>

                                      <button

                                        type="submit"

                                        className="main-btn mr2 "

                                      >

                                        {loading ? "Submitting..." : "Submit"}

                                      </button>

                                      <button

                                        type="button"

                                        className="main-btn ml2 closebtn"

                                        onClick={handleClosecart}

                                      >

                                        Close

                                      </button>

                                    </Modal.Footer>

                                  </form>

                                </Modal.Body>

                              </Modal>

                            </div>

                          </div>

                        </div>

                      </div>

                    </section>

                  </div>

                );

              })

            : null}

          <Footer />

        </>

      )}

    </>

  );

}



export default Productdetail;

